import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Fab, Hidden, Typography } from '@mui/material';
import GridItem from '@jumbo/components/GridItem';
import GridContainer from '@jumbo/components/GridContainer';
import { Delete } from '@mui/icons-material';
import ThemedTooltip from '@acnb/CustomComponents/Tooltip/ThemedTooltip';
import { FileTypeEnumValue } from 'enums/FileTypeEnum';
import useImage from 'services/Hooks/useImage';

const useStyles = makeStyles(() => ({
  pageFull: {
    width: '100%',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  deleteBtn: {
    position: 'absolute',
    right: '0',
    top: '0',
  },
  squareFab: {
    borderRadius: 0,
    width: 36,
    height: 36,
    minHeight: 36,
  },
}));

const CartWall = ({ wall, handleOpenDeleteWallModal, editablePanelTypeInventoryItems, index }) => {
  const { getPanelTypeImage } = useImage();

  const classes = useStyles();
  const { t } = useTranslation();
  // const headers = useMemo(() => {
  //   return wall?.cartWallInventoryItems?.map(cw => {
  //     return {
  //       ...cw,
  //       inventoryItem: editablePanelTypeInventoryItems.find(ii => ii.id === cw.inventoryItem_Id),
  //     };
  //   });
  // }, [editablePanelTypeInventoryItems, wall]);

  const numberOfPanelImages = wall?.images?.filter(
    i => i.fileType === FileTypeEnumValue.Photo && (!i.numberOfPanels || i.numberOfPanels === wall.numberOfPanels),
  );

  return (
    <Box className={classes.pageFull}>
      <GridContainer>
        {index !== 0 && (
          <GridItem xs={12}>
            <Divider />
          </GridItem>
        )}
        <GridItem
          xs={12}
          md={3}
          sx={{ alignSelf: 'center', p: '0 !important', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ p: 4 }}>
            <Box
              sx={{
                display: 'flex',
                alignContent: 'center',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                height: '100%',
              }}>
              <GridItem xs={12} md={3} sx={{ alignSelf: 'center' }}>
                <Box sx={{ textAlign: 'center' }}>
                  <ThemedTooltip key={`item-${wall.id}`} title={t('removeFromCart')} placement={'top'}>
                    <Fab
                      color="error"
                      size="small"
                      className={classes.squareFab}
                      onClick={() => {
                        handleOpenDeleteWallModal(wall);
                      }}>
                      <Delete />
                    </Fab>
                  </ThemedTooltip>
                </Box>
              </GridItem>
              <GridItem md={9} sx={{ alignSelf: 'center' }}>
                <Box className={classes.center}>
                  <img
                    src={
                      numberOfPanelImages?.length > 0
                        ? getPanelTypeImage(wall?.panelType_Id, numberOfPanelImages[0].id)
                        : '/images/brp-logo.png'
                    }
                    alt="img"
                    style={{ maxWidth: '20vh', width: '100%' }}
                  />
                </Box>
              </GridItem>
            </Box>
          </Box>
        </GridItem>
        <GridItem
          xs={12}
          md={5}
          lg={4}
          sx={{ alignSelf: 'center', p: '0 !important', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ p: 4 }}>
            <Typography variant="h1">{wall.name}</Typography>

            <Typography variant="h5" color="text.secondary" sx={{ mt: 1, mb: 1 }}>
              {`${wall.numberOfPanels}`} {t('panels')}
            </Typography>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <Box>
                <Typography variant="h2">{t('unitPrice')}</Typography>
              </Box>
              <Box>
                <Typography fontSize={25} fontWeight="bold">
                  ${wall?.price?.toFixed(2)} {wall.currencyName}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ mt: 2, mb: 2 }} />
            {wall.cartWallInventoryItems.map(header => (
              <Typography fontSize={15} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                {`${header?.quantity}X ${header?.name}`}
              </Typography>
            ))}
          </Box>
        </GridItem>
        <Hidden mdDown>
          <GridItem xs={12} md={2} lg={2} sx={{ alignSelf: 'center', p: '0 !important' }}>
            <Box fontSize={20} display="flex" justifyContent={'center'} alignItems={'center'}>
              <Box>
                <Typography variant="h2">{t('quantity')}</Typography>
              </Box>
            </Box>
            <Box display="flex" justifyContent={'center'} alignItems={'center'}>
              <Typography variant="h1">{wall.quantity}</Typography>
            </Box>
          </GridItem>
        </Hidden>

        <GridItem xs={12} md={2} lg={3}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              height: '100%',
            }}>
            <Hidden mdDown implementation="css">
              <Typography variant="h1">
                ${wall?.subTotal.toFixed(2)} {wall.currency}
              </Typography>
            </Hidden>
          </Box>
        </GridItem>

        <Hidden mdUp implementation="js">
          <GridItem xs={12}>
            <Divider />
            <Box
              xs={12}
              md={3}
              sx={{
                alignSelf: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                width: '100%',
                my: 3,
              }}>
              <Box fontSize={20} display="flex" justifyContent={'center'} alignItems={'center'}>
                <Box>
                  <Typography variant="h3">{t('quantity')}</Typography>
                </Box>
              </Box>
              <Box display="flex" justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h3">{wall.quantity}</Typography>
              </Box>
            </Box>
            <Divider />
            <Box
              xs={12}
              md={3}
              sx={{
                alignSelf: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                width: '100%',
                my: 3,
              }}>
              <Box fontSize={20} display="flex" justifyContent={'center'} alignItems={'center'}>
                <Box>
                  <Typography variant="h3">{t('price')}</Typography>
                </Box>
              </Box>
              <Box display="flex" justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h3">
                  ${wall?.subTotal.toFixed(2)} {wall.currencyName}
                </Typography>
              </Box>
            </Box>
          </GridItem>
        </Hidden>
      </GridContainer>
    </Box>
  );
};

export default CartWall;
